import { Component } from '@angular/core';
import { AgenxButtonComponent } from '../../atoms/button/button.component';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import Swal from 'sweetalert2';
import { AccountService } from '../../../../services/account.service';
import { OfflineService } from '../../../../services/offline.service';

@Component({
  selector: 'agenx-header',
  standalone: true,
  imports: [AgenxButtonComponent, RouterOutlet, RouterLink],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class AgenxHeaderComponent {
  constructor(
    private router: Router,
    private accountSrv: AccountService,
    private offlineSrv: OfflineService,
  ){}

  /**
   * Logs out. If there are gaugings waiting for connection, asks for confirmation
   * first because logging out clears the local storage where they are kept.
   */
  logout(): void {
    const gaugings = this.offlineSrv.loadFromLocal('gauging_pends', []).length;
    const specials = this.offlineSrv.loadFromLocal('specials_to_create', []).length;
    if (gaugings + specials === 0) {
      this.accountSrv.logout();
      this.router.navigateByUrl('');
      return;
    }

    const pends = [];
    gaugings > 0 && pends.push(`<b>${gaugings}</b> ${gaugings > 1 ? 'aforos' : 'aforo'}`);
    specials > 0 && pends.push(`<b>${specials}</b> ${specials > 1 ? 'aforos especiales' : 'aforo especial'}`);
    Swal.fire({
      title: 'Aforos pendientes por crear',
      html: `Tiene ${pends.join(' y ')} sin crear, esperando conexión.
        Si cierra sesión <b>se perderán</b>. ¿Desea cerrar sesión de todos modos?`,
      icon: 'warning',
      confirmButtonColor: '#e64544',
      cancelButtonColor: '#8b8b8c',
      confirmButtonText: 'Cerrar sesión',
      cancelButtonText: 'Cancelar',
      showCancelButton: true,
      focusCancel: true,
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.accountSrv.logout();
        this.router.navigateByUrl('');
      }
    });
  }
}
